import { useQuery } from 'react-query';

import { Inconsistency } from '../../../../backend/src/matter/inconsistency/inconsistency.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetAllSubsetInconsistencies = (matterId: string | null, subsetId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Inconsistency[]>(
    [QueryEntity.SubsetInconsistencies, { matterId, subsetId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/inconsistencies`, fetchConfigGET).then(
        (res) => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.json();
        },
      );
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
